<div class="mx-auto max-w-(--breakpoint-2xl)">
  @if (productsPage) {
    <app-data-table
      (route)="this.handleRoute($event)"
      [title]="'Products'"
      [dataPage]="productsPage"
      [columns]="tableColumns"
      [rowActions]="rowActions"
    >
      <div header class="flex w-full flex-row items-center justify-between gap-4">
        <div class="flex flex-1 items-center gap-4">
          <div class="flex-1 max-w-sm">
            <app-text-input [control]="searchControl" [placeholder]="'Search products...'"></app-text-input>
          </div>
          <div class="w-64">
            <app-select
              [height]="'11'"
              [multiple]="true"
              [control]="categoriesControl"
              [choices]="categories"
              [placeholder]="'Filter by categories'"></app-select>
          </div>
        </div>
        <div class="flex justify-end">
          <a routerLink="/products/create"
             class="inline-flex items-center gap-2 px-6 py-3 bg-brand-600 hover:bg-brand-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-200">
            <lucide-icon [name]="PlusIcon" size="18"></lucide-icon>
            Add Product
          </a>
        </div>
      </div>
    </app-data-table>
  }
</div>

<app-modal
  [title]="'Delete Product'"
  [content]="'Are you sure you want to delete product ' + productToDelete?.name + '?'"
  [show]="!!productToDelete"
  [closeButtonLabel]="'Cancel'"
  [confirmButtonLabel]="'Yes, Proceed'"
  (onClose)="productToDelete = undefined"
  (onConfirm)="deleteProductConfirmed()"
></app-modal>

@if (productDeleteError) {
  <app-modal
    [title]="'Error'"
    [content]="productDeleteError"
    [show]="!!productDeleteError"
    [closeButtonLabel]="'Close'"
    (onClose)="productDeleteError = undefined"
    [confirm]="false"
  ></app-modal>
}
